import {
    getApplicationProduct,
    listApplicationProducts
} from './queries';
import {
    createApplicationProduct,
    deleteApplicationProduct,
    updateApplicationProduct,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {ApplicationProduct} from "../types.ts";
import {generateClient} from "aws-amplify/api";

export type ListApplicationProducts = {
    listApplicationProducts: { items: ApplicationProduct[], nextToken?: string | null }
}

export type GetApplicationProduct = {
    getApplicationProduct: ApplicationProduct
}

export type CreateApplicationProduct = {
    createApplicationProduct: ApplicationProduct
}

export type UpdateApplicationProduct = {
    updateApplicationProduct: ApplicationProduct
}

export type DeleteApplicationProduct = {
    deleteApplicationProduct: string
}

const client = generateClient();

const normalizeFilter = (filter: { [key: string]: string }) => {
    return Object.keys(filter)
                 .reduce((acc: { [key: string]: string }, key: string) => {
                     if (filter[key] !== '') {
                         acc[key] = filter[key];
                     }
                     return acc;
                 }, {});

};

// Returns the PAGE, not a bare array: the caller needs `nextToken` to know
// whether anything remains. `limit` is the module's page size — a server
// concern under token pagination, never a user-facing "rows per page" choice.
export const fetchRecords = async (
    {
        filter,
        limit = 10,
        nextToken,
    }: {
        filter?: { [key: string]: string },
        limit?: number,
        nextToken?: string | null,
    } = {}
) => {

    // filter looks like this - {applicationId: 'XXXXXXXXXXXXX', productId: 'XXXXXXXXXXXXX'}

    let transformedFilter = {};
    if (typeof filter !== 'undefined') {
        transformedFilter = normalizeFilter(filter);
    }

    const response = await client.graphql<GraphQLQuery<ListApplicationProducts>>({
                                                                                     query: listApplicationProducts,
                                                                                     variables: {
                                                                                         filter: transformedFilter,
                                                                                         limit: limit,
                                                                                         nextToken: nextToken ?? null,
                                                                                     },
                                                                                 });

    return {
        items: response.data?.listApplicationProducts.items ?? [],
        nextToken: response.data?.listApplicationProducts.nextToken ?? null,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetApplicationProduct>>({
                                                                                   query: getApplicationProduct,
                                                                                   variables: {id: id},
                                                                               });
    return response.data?.getApplicationProduct;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateApplicationProduct>>({
                                                                                      query: createApplicationProduct,
                                                                                      variables: {input: payload},
                                                                                  });
    return response.data?.createApplicationProduct;
};

export const update = async (_id: string, record: ApplicationProduct) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateApplicationProduct>>({
                                                                                      query: (updateApplicationProduct),
                                                                                      variables: {input: record},
                                                                                  });
    return response.data?.updateApplicationProduct;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteApplicationProduct>>({
                                                                                      query: (deleteApplicationProduct),
                                                                                      variables: {input: {id: id}},

                                                                                  });
    return response.data?.deleteApplicationProduct;
};
